import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom'
import { fetchTranslations } from '../Redux/actions/translationsActions';
import TranslationText from './TranslationText';
import axiosBackend from '../axios/axios';
import $ from 'jquery';
import VerticalDivider from './VerticalDivider';
const baseURL = process.env.REACT_APP_BASE_URL;

export default function Header({ data }) {
    const [isloggedInUser, setIsloggedInUser] = useState(!!(localStorage.getItem('accessTokenforECUP') ?? '') ? true : false);
    const [language, setLanguage] = useState(localStorage.getItem('ecupLang') || 'en');
    const [liveEvent, setLiveEvent] = useState(false);
    const [isWideScreen, setIsWideScreen] = useState(true);
    const [menuIsShown, setMenuIsShown] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const menuBurger = useRef(null);

    useEffect(() => {
        if (!isWideScreen) {
            if (menuIsShown) {
                $(".headerMenu").slideDown(200);
                $(".menuOverLay").fadeIn();
            } else {
                $(".headerMenu").slideUp(200);
                $(".menuOverLay").fadeOut();
            }
        } else {
            $(".headerMenu").attr('style', '');
        }
    }, [menuIsShown, isWideScreen]);

    useEffect(() => {
        const handleResize = () => {
            setIsWideScreen(window.innerWidth >= 943);
        };

        handleResize(); // Initial check
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        const token = localStorage.getItem('accessTokenforECUP') ?? '';
        if (!!token) {
            setIsloggedInUser(true);
        } else {
            setIsloggedInUser(false);
        }
    }, [navigate]);

    const handleLogout = () => {
        localStorage.clear();
        navigate('/');
        window.location.reload();
    }
    // hangle language Change

    useEffect(() => {
        if (language == 'ar') {
            document.documentElement.dir = 'rtl'; // Set the "dir" attribute on <html>
            document.documentElement.lang = language;    // Set the "lang" attribute on <html>
        }
    }, [language]); // Re-run when direction or lang changes

    useEffect(() => {
        dispatch(fetchTranslations());
    }, [language]);

    function chengelanguage() {
        if (language == 'en') {
            localStorage.setItem('ecupLang', 'ar');
            setLanguage('ar');
            window.location.reload();
        } else {
            localStorage.setItem('ecupLang', 'en');
            setLanguage('en');
            window.location.reload();
        }
    }

    // checkLive event
    async function checkLiveEvent() {
        try {
            const res = await axiosBackend.get('/api/Show/CheckLiveEvent');

            console.log('live event is', res?.data);
            if (res.status == 200) {
                if (res.data.responseCode == "200") {
                    if (res.data?.result?.liveLink != "" && res.data?.result?.liveLink != null) {
                        setLiveEvent(res.data?.result?.id);
                    }
                }
            }
        } catch (error) {
            console.error('error in getting live Event')
        }
    }
    useEffect(() => {
        checkLiveEvent();
    }, [])

    return (
        <>
            {/* <!-- Menu OverLay div --> */}
            {language == 'ar' &&
                <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.rtl.min.css" integrity="sha384-gXt9imSW0VcJVHezoNQsP+TNrjYXoGcrqBZJpry9zJt8PCQjobwmhMGaDHTASo9N" crossorigin="anonymous" />}
            {language == 'en' &&
                <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" rel="stylesheet"
                    integrity="sha384-QWTKZyjpPEjISv5WaRU9OFeRpok6YctnYmDr5pNlyT2bRjXh0JMhjY6hW+ALEwIH" crossorigin="anonymous" />}

            <link rel="stylesheet" href={`${baseURL}/css/style.css`} />
            {language == 'ar' && <link rel="stylesheet" href={`${baseURL}/css/rtl.css`} />}
            <div onClick={() => setMenuIsShown(false)} className="menuOverLay"></div>
            {/* <!-- header --> */}
            <div className="headerContainer">
                <div className="container">
                    <div className="header">
                        <img className="headerLogo" src="./img/logo.png" alt="logo" />
                        <div className="searchBar">
                            <i className="fa fa-search" aria-hidden="true"></i>
                            <input type="text" placeholder="Search" name="search" id="" />
                        </div>
                        <style>
                            {`.headerMenu{
                            width:unset !important;
                            }`}
                        </style>
                        <div className="headerMenu">
                            {!!liveEvent &&
                                <>
                                    <Link to={`/showDetails?id=${liveEvent}`} className="menuItem roboto-regular d-flex">
                                        <div className='bg-danger rounded-circle liveCircle my-auto mx-2' />
                                        <TranslationText defaultText={'Live'} textkey={'web.liveEvent'} key={'Live'} />
                                    </Link>

                                </>
                            }
                            {HeaderItem({ link: "/", defaultText: 'Home', textkey: 'Home' })}
                            {HeaderItem({ link: "/rules", defaultText: 'Rules', textkey: 'Rules' })}
                            {HeaderItem({ link: "/calender", defaultText: 'Calendar', textkey: 'Calendar' })}
                            {/* {HeaderItem({ link: "/otherShows", defaultText: 'OtherShows', textkey: 'OtherShows' })} */}
                            {HeaderItem({ link: "/news", defaultText: 'News', textkey: 'News' })}
                            {HeaderItem({ link: "/gallery", defaultText: 'photo Gallery', textkey: 'web.photoGallery' })}
                            {HeaderItem({ link: "/#aboutSection", defaultText: 'About Us', textkey: 'About' })}
                            {HeaderItem({ link: "/contactUs", defaultText: 'Contact us', textkey: 'Contact' })}

                            {/* <Link to="/ecupCommittee" className="menuItem roboto-regular">
                                <TranslationText defaultText={'ECup Committee'} textkey={'ECupCommittee'} key={'ECupCommittee'} />
                            </Link> */}


                            {isloggedInUser ?
                                <div class="dropdown">
                                    {/* <Link to="/profile" className="menuItem roboto-regular btn btn-secondary dropdown-toggle" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Profile
                                    </Link> */}
                                    <div class="menuItem roboto-regular dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                        <TranslationText defaultText={'My Profile'} textkey={'web.myProfile'} key={'My Profile'} />
                                    </div>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                        <li>
                                            <Link to="/profile" class="dropdown-item">
                                                <TranslationText defaultText={'Account Setting'} textkey={'web.accountSetting'} key={'Account Setting'} />
                                            </Link></li>
                                        <li><div class="dropdown-item" onClick={handleLogout}>
                                            <TranslationText defaultText={'LogOut'} textkey={'web.logout'} key={'Log out'} />
                                        </div></li>
                                    </ul>
                                </div>
                                :
                                HeaderItem({ link: "/login", defaultText: 'Login', textkey: 'web.login' })
                            }
                            <Link onClick={() => { chengelanguage() }} className="menuItem roboto-regular" style={{ fontFamily: 'Cairo' }}>
                                {language == 'en' ?
                                    <>
                                        <TranslationText defaultText={'AR'} textkey={'web.ar'} key={'AR'} />
                                        <img src="./img/ar.png" className="langicon ms-1" alt="" />
                                    </>
                                    :
                                    <>
                                        <TranslationText defaultText={'انكليزي'} textkey={'web.en'} key={'EN'} />
                                        <img src="./img/en.png" className="langicon ms-1" alt="" />
                                    </>
                                }
                            </Link>
                        </div>
                        <a ref={menuBurger} onClick={() => setMenuIsShown(!menuIsShown)} className="BurgerIcon">
                            <i className="fa fa-bars" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </div >
        </>
    )
}
function HeaderItem({ link, defaultText, textkey, withDivider = true }) {
    return <>
        <Link to={link} className="menuItem roboto-regular">
            <TranslationText defaultText={defaultText} textkey={textkey} key={textkey} />
        </Link>
        {withDivider &&
            <VerticalDivider />
        }
    </>
}

